export function getLabelFromSliderList(list, value) {
  const item = list.filter((x) => x.value === value);
  return item && item.length > 0 ? item[0].label : "";
}
